export const c_menu_m_drilled_in_c_menu__list_item_m_current_path_c_menu_ZIndex = {
  "name": "--pf-c-menu--m-drilled-in--c-menu__list-item--m-current-path--c-menu--ZIndex",
  "value": "100",
  "var": "var(--pf-c-menu--m-drilled-in--c-menu__list-item--m-current-path--c-menu--ZIndex)"
};
export default c_menu_m_drilled_in_c_menu__list_item_m_current_path_c_menu_ZIndex;